var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import { AutoComplete } from 'antd';
import Input from "@codex/components/forms/Input";
import API from '@codex/utils/services';
var EmployeerAutoCompleteInput = /** @class */ (function (_super) {
    __extends(EmployeerAutoCompleteInput, _super);
    function EmployeerAutoCompleteInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            employerList: [],
        };
        _this.fetchEmployerList = function (val) { return __awaiter(_this, void 0, void 0, function () {
            var response, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, API.noAuth.get("employer?filter=" + val)];
                    case 1:
                        response = _a.sent();
                        if (response.data && val === this.lastValue) {
                            this.setState({ employerList: response.data });
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    EmployeerAutoCompleteInput.prototype.componentWillUnmount = function () {
        window.clearTimeout(this.debouceTimeout);
    };
    EmployeerAutoCompleteInput.prototype.componentDidMount = function () {
        console.log(this.props.question);
    };
    EmployeerAutoCompleteInput.prototype.tryToFetch = function (val) {
        var _this = this;
        window.clearTimeout(this.debouceTimeout);
        if (this.lastValue !== undefined && this.lastValue !== val) {
            this.props.onChangeEmployerName(val);
        }
        if (val !== this.lastValue) {
            this.setState({ employerList: [] });
        }
        this.lastValue = val;
        this.debouceTimeout = window.setTimeout(function () { return _this.fetchEmployerList(val); }, 400);
    };
    EmployeerAutoCompleteInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, question = _a.question, rest = __rest(_a, ["question"]);
        return (React.createElement(AutoComplete, { dataSource: this.state.employerList.map(function (e) { return ({ value: e.employerId.toString(), text: e.employerName }); }), onSelect: function (value) {
                _this.setState({ employerList: [] });
                var employerId = Number(value);
                var employer = _this.state.employerList.find(function (e) { return e.employerId === employerId; });
                if (employer) {
                    _this.props.onChangeEmployerIdAndName(employerId, employer.employerName);
                }
            }, defaultValue: question.answer || '' },
            React.createElement(Input, __assign({ name: "" + question.id, question: question, size: "large", onFocus: function (e) { return _this.tryToFetch(e.target.value); }, placeholder: question.placeholder, dir: "rtl", onBlur: function () { return _this.setState({ employerList: [] }); }, autoComplete: "off", onInput: function (e) { return _this.tryToFetch(e.currentTarget.value); } }, rest))));
    };
    return EmployeerAutoCompleteInput;
}(Component));
export default EmployeerAutoCompleteInput;



//////////////////
// WEBPACK FOOTER
// ./src/components/EmployerAutoCompleteInput/EmployerAutoCompleteInput.tsx
// module id = 1511
// module chunks = 0